// // import React, { useState } from "react";
// // import { MapPin, Phone } from "lucide-react";
// // import toast from "react-hot-toast";

// // const ProjectDetailsPartOne = ({ projectData }) => {
// //   const [formData, setFormData] = useState({
// //     name: "",
// //     phone: "",
// //     email: "",
// //     message: "",
// //   });

// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [submitMessage, setSubmitMessage] = useState("");

// //   const handleInputChange = (e) => {
// //     setFormData({
// //       ...formData,
// //       [e.target.name]: e.target.value,
// //     });
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (!formData.name || !formData.email || !formData.phone) {
// //       setSubmitMessage("Please fill in all required fields.");
// //       return;
// //     }

// //     setIsSubmitting(true);
// //     setSubmitMessage("");

// //     try {
// //       const response = await fetch(
// //         `${process.env.REACT_APP_API_URL}/inquiry/create-inquiry`,
// //         {
// //           method: "POST",
// //           headers: {
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify({
// //             name: formData.name,
// //             email: formData.email,
// //             phone: formData.phone,
// //             message: formData.message,
// //             status: "inquireOn",
// //           }),
// //         }
// //       );

// //       if (response.ok) {
// //         const result = await response.json();
// //         console.log("Success:", result);
// //         toast.success("Submitted Successfully");
// //         setSubmitMessage(
// //           "Thank you! Your inquiry has been submitted successfully. We'll get back to you soon."
// //         );

// //         // Reset form
// //         setFormData({
// //           name: "",
// //           phone: "",
// //           email: "",
// //           message: "",
// //         });
// //       } else {
// //         throw new Error("Network response was not ok");
// //       }
// //     } catch (error) {
// //       console.error("Error:", error);
// //       setSubmitMessage(
// //         "Sorry, there was an error submitting your inquiry. Please try again later."
// //       );
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   if (!projectData) {
// //     return <div>Loading...</div>;
// //   }

// //   return (
// //     <div className="bg-gray-50 p-2 sm:p-3 md:p-4 lg:p-4 xl:p-6">
// //       <div className="">
// //         <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
// //           {/* Left Column - Property Details */}
// //           <div className="bg-white rounded-lg shadow-lg p-4 sm:p-5 md:p-6 lg:p-8">
// //             {/* For Sale Badge */}
// //             <div className="inline-block bg-green-500 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-xs sm:text-sm font-medium mb-3 sm:mb-4">
// //               For Sale
// //             </div>

// //             {/* Property Title */}
// //             <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
// //               {projectData.projectName}
// //             </h1>

// //             {/* Location */}
// //             <div className="flex items-center text-gray-600 mb-6 sm:mb-8">
// //               <MapPin className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-red-500 flex-shrink-0" />
// //               <span className="text-sm sm:text-base">
// //                 {projectData.location}
// //               </span>
// //             </div>

// //             {/* Description Section */}
// //             <div className="mb-6 sm:mb-8">
// //               <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4 border-l-4 border-red-500 pl-3 sm:pl-4">
// //                 Description
// //               </h2>
// //               <div className="text-gray-700 leading-relaxed space-y-3 sm:space-y-4 text-sm sm:text-base">
// //                 <p>{projectData.description}</p>
// //               </div>
// //             </div>

// //             {/* Nearest Location Section */}
// //             <div>
// //               <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4 sm:mb-6 border-l-4 border-red-500 pl-3 sm:pl-4">
// //                 Nearest Location
// //               </h2>

// //               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 bg-[#F2F6F7] p-3 sm:p-4 rounded-md">
// //                 {projectData.popularPlaces &&
// //                 projectData.popularPlaces.length > 0 ? (
// //                   <>
// //                     <div className="space-y-3 sm:space-y-4">
// //                       {projectData.popularPlaces
// //                         .slice(
// //                           0,
// //                           Math.ceil(projectData.popularPlaces.length / 2)
// //                         )
// //                         .map((place, index) => (
// //                           <div
// //                             key={place._id || index}
// //                             className="flex justify-between items-center py-2 sm:py-3 border-b border-gray-200"
// //                           >
// //                             <span className="text-gray-600 text-sm sm:text-base">
// //                               {place.name}:
// //                             </span>
// //                             <span className="font-semibold text-gray-900 text-sm sm:text-base">
// //                               {place.distance}
// //                             </span>
// //                           </div>
// //                         ))}
// //                     </div>

// //                     <div className="space-y-3 sm:space-y-4">
// //                       {projectData.popularPlaces
// //                         .slice(Math.ceil(projectData.popularPlaces.length / 2))
// //                         .map((place, index) => (
// //                           <div
// //                             key={place._id || index}
// //                             className="flex justify-between items-center py-2 sm:py-3 border-b border-gray-200"
// //                           >
// //                             <span className="text-gray-600 text-sm sm:text-base">
// //                               {place.name}:
// //                             </span>
// //                             <span className="font-semibold text-gray-900 text-sm sm:text-base">
// //                               {place.distance}
// //                             </span>
// //                           </div>
// //                         ))}
// //                     </div>
// //                   </>
// //                 ) : (
// //                   <div className="col-span-2 text-center text-gray-500">
// //                     No location data available
// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //           </div>

// //           <div className="space-y-4 sm:space-y-6">
// //             <div className="bg-white rounded-lg shadow-lg p-4 sm:p-5 md:p-6 lg:p-8">
// //               <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
// //                 Fill up the <span className="text-red-500">Inquiry</span> Form
// //               </h2>
// //               <p className="text-gray-600 mb-6 sm:mb-8 text-sm sm:text-base">
// //                 Let us help you find your dream property. Please fill in the
// //                 details below and our expert will get in touch with you shortly.
// //               </p>

// //               <form onSubmit={handleSubmit}>
// //                 <div className="space-y-4 sm:space-y-6">
// //                   <div>
// //                     <input
// //                       type="text"
// //                       name="name"
// //                       placeholder="Your Name *"
// //                       value={formData.name}
// //                       onChange={handleInputChange}
// //                       required
// //                       className="w-full px-3 sm:px-4 py-3 sm:py-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-gray-50 text-sm sm:text-base"
// //                     />
// //                   </div>

// //                   <div>
// //                     <input
// //                       type="tel"
// //                       name="phone"
// //                       placeholder="Your Phone *"
// //                       value={formData.phone}
// //                       onChange={handleInputChange}
// //                       required
// //                       className="w-full px-3 sm:px-4 py-3 sm:py-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-gray-50 text-sm sm:text-base"
// //                     />
// //                   </div>

// //                   <div>
// //                     <input
// //                       type="email"
// //                       name="email"
// //                       placeholder="Your Email *"
// //                       value={formData.email}
// //                       onChange={handleInputChange}
// //                       required
// //                       className="w-full px-3 sm:px-4 py-3 sm:py-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-gray-50 text-sm sm:text-base"
// //                     />
// //                   </div>

// //                   <div>
// //                     <textarea
// //                       name="message"
// //                       placeholder="Message"
// //                       rows="4"
// //                       value={formData.message}
// //                       onChange={handleInputChange}
// //                       className="w-full px-3 sm:px-4 py-3 sm:py-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-gray-50 resize-none text-sm sm:text-base"
// //                     ></textarea>
// //                   </div>

// //                   {submitMessage && (
// //                     <div
// //                       className={`p-3 rounded-lg text-sm ${
// //                         submitMessage.includes("error") ||
// //                         submitMessage.includes("Sorry")
// //                           ? "bg-red-100 text-red-700 border border-red-200"
// //                           : submitMessage.includes("Thank you")
// //                           ? "bg-green-100 text-green-700 border border-green-200"
// //                           : "bg-yellow-100 text-yellow-700 border border-yellow-200"
// //                       }`}
// //                     >
// //                       {submitMessage}
// //                     </div>
// //                   )}

// //                   <button
// //                     type="submit"
// //                     disabled={isSubmitting}
// //                     className={`w-full font-semibold py-3 sm:py-4 px-4 sm:px-6 rounded-lg transition-colors duration-200 text-sm sm:text-base ${
// //                       isSubmitting
// //                         ? "bg-gray-400 cursor-not-allowed text-white"
// //                         : "bg-red-500 hover:bg-red-600 text-white"
// //                     }`}
// //                   >
// //                     {isSubmitting ? "Submitting..." : "Submit"}
// //                   </button>
// //                 </div>
// //               </form>
// //             </div>

// //             <div className="relative w-full h-32 sm:h-40 rounded-lg overflow-hidden shadow-lg">
// //               <div
// //                 className="absolute inset-0 bg-cover bg-center"
// //                 style={{
// //                   backgroundImage: `url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=300&fit=crop')`,
// //                 }}
// //               >
// //                 <div className="absolute inset-0 bg-black bg-opacity-20"></div>
// //               </div>

// //               <div className="absolute inset-0 flex items-center justify-center">
// //                 <div className="bg-white rounded-full px-6 sm:px-8 py-3 sm:py-4 shadow-lg flex items-center space-x-3 sm:space-x-4">
// //                   <div className="bg-black rounded-full p-2 sm:p-2.5">
// //                     <Phone className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
// //                   </div>

// //                   <div className="text-black font-bold text-lg sm:text-xl lg:text-2xl">
// //                     +91 9999 7777 66
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ProjectDetailsPartOne;

// import React, { useState } from "react";
// import { MapPin, Phone, ChevronLeft, ChevronRight } from "lucide-react";

// // Slider Component
// const Slider = ({ images = [] }) => {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   // Transform API images to the format expected by the slider
//   const sliderImages =
//     images.length > 0
//       ? images.map((url, index) => ({
//           id: index + 1,
//           url: url,
//           alt: `Project image ${index + 1}`,
//         }))
//       : [];

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide(
//       (prev) => (prev - 1 + sliderImages.length) % sliderImages.length
//     );
//   };

//   const goToSlide = (index) => {
//     setCurrentSlide(index);
//   };

//   if (sliderImages.length === 0) {
//     return (
//       <div className="w-full h-48 sm:h-56 md:h-64 lg:h-96 xl:h-[28rem] bg-gray-200 rounded-lg flex items-center justify-center">
//         <p className="text-gray-500">No images available</p>
//       </div>
//     );
//   }

//   return (
//     <div className="relative w-full h-48 sm:h-56 md:h-64 lg:h-96 xl:h-[28rem] bg-gray-100 rounded-lg overflow-hidden shadow-lg">
//       {/* Main Image Container */}
//       <div className="relative w-full h-full overflow-hidden">
//         <div
//           className="flex transition-transform duration-500 ease-in-out h-full"
//           style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//         >
//           {sliderImages.map((image, index) => (
//             <div key={image.id} className="min-w-full h-full relative">
//               <img
//                 src={image.url}
//                 alt={image.alt}
//                 className="w-full h-full object-cover"
//               />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* For Sale Badge */}
//       <div className="absolute top-4 left-4 bg-green-500 text-white px-3 py-1 rounded-md text-sm font-medium z-20">
//         For Sale
//       </div>

//       {/* Left Arrow */}
//       <button
//         onClick={prevSlide}
//         className="absolute left-2 sm:left-3 md:left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-1.5 sm:p-2 shadow-md transition-all duration-200 z-10"
//         aria-label="Previous image"
//       >
//         <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
//       </button>

//       {/* Right Arrow */}
//       <button
//         onClick={nextSlide}
//         className="absolute right-2 sm:right-3 md:right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-1.5 sm:p-2 shadow-md transition-all duration-200 z-10"
//         aria-label="Next image"
//       >
//         <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
//       </button>

//       {/* Dot Indicators */}
//       <div className="absolute bottom-2 sm:bottom-3 md:bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-1.5 sm:space-x-2 z-10">
//         {sliderImages.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => goToSlide(index)}
//             className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-200 ${
//               index === currentSlide
//                 ? "bg-white shadow-md"
//                 : "bg-white bg-opacity-50 hover:bg-opacity-75"
//             }`}
//             aria-label={`Go to slide ${index + 1}`}
//           />
//         ))}
//       </div>

//       {/* Slide Counter */}
//       <div className="absolute top-2 sm:top-3 md:top-4 right-2 sm:right-3 md:right-4 bg-black bg-opacity-50 text-white px-1.5 sm:px-2 py-0.5 sm:py-1 rounded text-xs sm:text-sm z-20">
//         {currentSlide + 1} / {sliderImages.length}
//       </div>
//     </div>
//   );
// };

// const ProjectDetailsPartOne = ({ projectData }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     message: "",
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitMessage, setSubmitMessage] = useState("");

//   // Mock data for demonstration
//   const mockProjectData = projectData || {
//     projectName: "Covenants MI CASA",
//     location: "Kanakapura, Bhubaneswar",
//     description:
//       "Covenants Developers Pvt. Ltd, a professionally managed leading company is involved in construction of Apartments, Duplex, Interior Design, Land Scaping, Farm House Projects and Construction of Individual Houses. Covenants Developers Pvt. Ltd. is a reliable and trusted name in the real estate sector of Bhubaneswar. Covenants offers the best. L.g. is a professional real estate company which is registered with Credai (based in Bhubaneswar, Odisha). We expertise in the field of selling and buying of plots, building duplex, apartments and other construction works. For our valued and residential service to the customers, we have attained a remark of being a notable real estate company in the state. The mission is to be the most successful real estate company in the state of Odisha.",
//     images: [
//       "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=600&fit=crop",
//       "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop",
//       "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop",
//       "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop",
//       "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&h=600&fit=crop",
//     ],
//   };

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     if (!formData.name || !formData.email || !formData.phone) {
//       setSubmitMessage("Please fill in all required fields.");
//       return;
//     }

//     setIsSubmitting(true);
//     setSubmitMessage("");

//     try {
//       // Simulate API call
//       await new Promise((resolve) => setTimeout(resolve, 1000));

//       setSubmitMessage(
//         "Thank you! Your inquiry has been submitted successfully. We'll get back to you soon."
//       );

//       // Reset form
//       setFormData({
//         name: "",
//         phone: "",
//         email: "",
//         message: "",
//       });
//     } catch (error) {
//       console.error("Error:", error);
//       setSubmitMessage(
//         "Sorry, there was an error submitting your inquiry. Please try again later."
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="bg-white min-h-screen">
//       <div className="w-full mx-auto p-4">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//           {/* Left Column - Images and Details */}
//           <div className="lg:col-span-2 space-y-6">
//             {/* Image Slider */}
//             <Slider images={mockProjectData.images} />

//             {/* Property Details */}
//             <div className="bg-white rounded-lg p-6">
//               {/* Property Title */}
//               <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
//                 {mockProjectData.projectName}
//               </h1>

//               {/* Location */}
//               <div className="flex items-center text-gray-600 mb-6">
//                 <MapPin className="w-5 h-5 mr-2 text-red-500 flex-shrink-0" />
//                 <span className="text-base">{mockProjectData.location}</span>
//               </div>

//               {/* Description Section */}
//               <div className="mb-6">
//                 <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
//                   <div className="w-1 h-6 bg-red-500 mr-3"></div>
//                   Description
//                 </h2>
//                 <div className="text-gray-700 leading-relaxed">
//                   <p>{mockProjectData.description}</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - Inquiry Form */}
//           <div className="lg:col-span-1">
//             <div className="bg-gray-50 rounded-lg p-6 sticky top-4">
//               <h2 className="text-2xl font-bold text-gray-900 mb-2">
//                 Fill up the <span className="text-red-500">Inquiry</span> Form
//               </h2>
//               <p className="text-gray-600 mb-6 text-sm">
//                 Let us help you find your dream property. Please fill in the
//                 details below and our expert will get in touch with you shortly.
//               </p>

//               <div className="space-y-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="name"
//                     placeholder="Your Name"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-white text-sm"
//                   />
//                 </div>

//                 <div>
//                   <input
//                     type="tel"
//                     name="phone"
//                     placeholder="Your Phone"
//                     value={formData.phone}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-white text-sm"
//                   />
//                 </div>

//                 <div>
//                   <input
//                     type="email"
//                     name="email"
//                     placeholder="Your Email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-white text-sm"
//                   />
//                 </div>

//                 <div>
//                   <textarea
//                     name="message"
//                     placeholder="Message"
//                     rows="4"
//                     value={formData.message}
//                     onChange={handleInputChange}
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-white resize-none text-sm"
//                   ></textarea>
//                 </div>

//                 {submitMessage && (
//                   <div
//                     className={`p-3 rounded-lg text-sm ${
//                       submitMessage.includes("error") ||
//                       submitMessage.includes("Sorry")
//                         ? "bg-red-100 text-red-700 border border-red-200"
//                         : submitMessage.includes("Thank you")
//                         ? "bg-green-100 text-green-700 border border-green-200"
//                         : "bg-yellow-100 text-yellow-700 border border-yellow-200"
//                     }`}
//                   >
//                     {submitMessage}
//                   </div>
//                 )}

//                 <button
//                   type="button"
//                   onClick={handleSubmit}
//                   disabled={isSubmitting}
//                   className={`w-full font-semibold py-3 px-6 rounded-lg transition-colors duration-200 text-sm ${
//                     isSubmitting
//                       ? "bg-gray-400 cursor-not-allowed text-white"
//                       : "bg-red-500 hover:bg-red-600 text-white"
//                   }`}
//                 >
//                   {isSubmitting ? "Submitting..." : "Submit"}
//                 </button>
//               </div>

//               {/* Phone Contact Section */}
//               <div className="mt-8 relative">
//                 <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg p-6 text-center relative overflow-hidden">
//                   <div className="absolute inset-0 bg-black bg-opacity-20"></div>
//                   <div className="relative z-10">
//                     <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
//                       <Phone className="w-8 h-8 text-blue-600" />
//                     </div>
//                     <div className="text-white font-bold text-xl">
//                       +91 9999 7777 66
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProjectDetailsPartOne;

import React, { useState } from "react";
import {
  MapPin,
  Phone,
  ChevronLeft,
  ChevronRight,
  Calendar,
  Home,
} from "lucide-react";

// Slider Component
const Slider = ({ images = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Transform API images to the format expected by the slider
  const sliderImages =
    images.length > 0
      ? images.map((url, index) => ({
          id: index + 1,
          url: url,
          alt: `Project image ${index + 1}`,
        }))
      : [];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + sliderImages.length) % sliderImages.length
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  if (sliderImages.length === 0) {
    return (
      <div className="w-full h-48 sm:h-56 md:h-64 lg:h-96 xl:h-[28rem] bg-gray-200 rounded-lg flex items-center justify-center">
        <p className="text-gray-500">No images available</p>
      </div>
    );
  }

  return (
    <div className="relative w-full h-48 sm:h-56 md:h-64 lg:h-96 xl:h-[28rem] bg-gray-100 rounded-lg o shadow-lg hide-scrollbar">
      {/* Main Image Container */}
      <div className="relative w-full h-full overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out h-full"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {sliderImages.map((image, index) => (
            <div key={image.id} className="min-w-full h-full relative">
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>

      {/* For Sale Badge */}
      <div className="absolute top-4 left-4 bg-green-500 text-white px-3 py-1 rounded-md text-sm font-medium z-20">
        For Sale
      </div>

      {/* Left Arrow */}
      <button
        onClick={prevSlide}
        className="absolute left-2 sm:left-3 md:left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-1.5 sm:p-2 shadow-md transition-all duration-200 z-10"
        aria-label="Previous image"
      >
        <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
      </button>

      {/* Right Arrow */}
      <button
        onClick={nextSlide}
        className="absolute right-2 sm:right-3 md:right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-1.5 sm:p-2 shadow-md transition-all duration-200 z-10"
        aria-label="Next image"
      >
        <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
      </button>

      {/* Dot Indicators */}
      <div className="absolute bottom-2 sm:bottom-3 md:bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-1.5 sm:space-x-2 z-10">
        {sliderImages.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-200 ${
              index === currentSlide
                ? "bg-white shadow-md"
                : "bg-white bg-opacity-50 hover:bg-opacity-75"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Slide Counter */}
      <div className="absolute top-2 sm:top-3 md:top-4 right-2 sm:right-3 md:right-4 bg-black bg-opacity-50 text-white px-1.5 sm:px-2 py-0.5 sm:py-1 rounded text-xs sm:text-sm z-20">
        {currentSlide + 1} / {sliderImages.length}
      </div>
    </div>
  );
};

const ProjectDetailsPartOne = ({ projectData }) => {
  if (!projectData) {
    return <div>Loading project details...</div>;
  }

  // Process amenities - API returns array of strings directly
  const amenities =
    projectData.amenities && Array.isArray(projectData.amenities)
      ? projectData.amenities
      : [];

  // Process extraFacilities - API returns array of strings directly
  const extraFacilities =
    projectData.extraFacilities && Array.isArray(projectData.extraFacilities)
      ? projectData.extraFacilities
      : [];

  return (
    <div className="bg-white hide-scrollbar">
      <div className="space-y-6">
        {/* Image Slider */}
        <Slider images={projectData.images || []} />

        {/* Property Details */}
        <div className="bg-white rounded-lg">
          {/* Property Title */}
          <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            {projectData.projectName}
          </h1>

          {/* Location */}
          <div className="flex items-center text-gray-600 mb-4">
            <MapPin className="w-5 h-5 mr-2 text-red-500 flex-shrink-0" />
            <span className="text-base">{projectData.location}</span>
          </div>

          {/* Project Type */}
          <div className="flex items-center text-gray-600 mb-4">
            <Home className="w-5 h-5 mr-2 text-blue-500 flex-shrink-0" />
            <span className="text-base capitalize font-medium">
              {projectData.projectType}
            </span>
          </div>

          {/* Description Section */}
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
              <div className="w-1 h-6 bg-red-500 mr-3"></div>
              Description
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p>{projectData.description}</p>
            </div>
          </div>

{/* Amenities Section */}
          {amenities.length > 0 && (
            <div className="mb-6">
              <div className="flex items-center gap-2 mb-3 sm:mb-4">
                <div className="w-1 h-5 sm:h-6 bg-red-500"></div>
                <h2 className="text-base sm:text-lg lg:text-xl xl:text-2xl font-semibold text-gray-800">
                  Amenities
                </h2>
              </div>

              {/* Amenities Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-2 sm:gap-3">
                {amenities.map((amenity, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 text-xs sm:text-sm text-gray-700"
                  >
                    <div className="w-4 h-4 sm:w-5 sm:h-5 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full"></div>
                    </div>
                    <span className="flex-1">{amenity}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          

          {/* Gallery Section */}
          <div className="mb-6">
            <div className="flex items-center gap-2 mb-3 sm:mb-4">
              <div className="w-1 h-5 sm:h-6 bg-red-500"></div>
              <h2 className="text-base sm:text-lg lg:text-xl xl:text-2xl font-semibold text-gray-800">
                From Our Gallery
              </h2>
            </div>

            {/* Gallery Grid */}
            <div className="grid grid-cols-2 gap-1.5 sm:gap-2 h-40 sm:h-48 md:h-64 lg:h-80 xl:h-96">
              <div className="rounded-lg grid grid-cols-1 grid-rows-2 gap-1.5 sm:gap-2">
                {projectData.images && projectData.images.length > 0 ? (
                  <>
                    <div
                      className="bg-gray-100 rounded-lg bg-cover bg-center"
                      style={{
                        backgroundImage: `url(${projectData.images[0] || ""})`,
                      }}
                    ></div>
                    <div
                      className="bg-gray-200 rounded-lg bg-cover bg-center"
                      style={{
                        backgroundImage: `url(${
                          projectData.images[1] || projectData.images[0] || ""
                        })`,
                      }}
                    ></div>
                  </>
                ) : (
                  <>
                    <div className="bg-gray-200 rounded-lg"></div>
                    <div className="bg-gray-200 rounded-lg"></div>
                  </>
                )}
              </div>
              <div
                className="bg-gray-200 rounded-lg bg-cover bg-center"
                style={{
                  backgroundImage:
                    projectData.images && projectData.images.length > 2
                      ? `url(${projectData.images[2]})`
                      : projectData.images && projectData.images.length > 0
                      ? `url(${projectData.images[0]})`
                      : "none",
                }}
              ></div>
            </div>
          </div>

          {/* Popular Places */}
          {projectData.popularPlaces &&
            projectData.popularPlaces.length > 0 && (
              <div className="mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                  <div className="w-1 h-6 bg-green-500 mr-3"></div>
                  Nearby Places
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {projectData.popularPlaces.map((place, index) => (
                    <div
                      key={place._id || index}
                      className="flex justify-between items-center bg-gray-50 p-3 rounded-lg"
                    >
                      <span className="font-medium text-gray-800">
                        {place.name}
                      </span>
                      <span className="text-sm text-green-600 font-medium">
                        {place.distance}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

          {/* Extra Facilities Section */}
          {extraFacilities.length > 0 && (
            <div className="mb-6">
              <div className="flex items-center gap-2 mb-3 sm:mb-4">
                <div className="w-1 h-5 sm:h-6 bg-red-500"></div>
                <h2 className="text-base sm:text-lg lg:text-xl xl:text-2xl font-semibold text-gray-800">
                  Facilities
                </h2>
              </div>

              {/* Extra Facilities Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-2 sm:gap-3">
                {extraFacilities.map((facility, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 text-xs sm:text-sm text-gray-700"
                  >
                    <div className="w-4 h-4 sm:w-5 sm:h-5 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full"></div>
                    </div>
                    <span className="flex-1">{facility}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Specifications Section */}
          {projectData.specifications &&
            projectData.specifications.length > 0 && (
              <div>
                <div className="flex items-center gap-2 mb-3 sm:mb-4">
                  <div className="w-1 h-5 sm:h-6 bg-red-500"></div>
                  <h2 className="text-base sm:text-lg lg:text-xl xl:text-2xl font-semibold text-gray-800">
                    Specifications
                  </h2>
                </div>

                <div className="space-y-3 sm:space-y-4">
                  {projectData.specifications.map((spec, index) => (
                    <div
                      key={spec._id || index}
                      className="bg-gray-200 p-3 sm:p-4 rounded-lg"
                    >
                      <h3 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base">
                        {spec.heading}
                      </h3>
                      <ul className="space-y-1">
                        {spec.subHeadings &&
                          spec.subHeadings.map((subHeading, subIndex) => (
                            <li
                              key={subIndex}
                              className="text-sm text-gray-600 flex items-center gap-2"
                            >
                              <div className="w-1.5 h-1.5 bg-red-500 rounded-full flex-shrink-0"></div>
                              {subHeading}
                            </li>
                          ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsPartOne;
